export default function Card({ children, className = "", hover = false, onClick, noPad = false, title, subtitle, action }) {
  return (
    <div onClick={onClick} className={`bg-white dark:bg-slate-900 rounded-xl2 border border-border dark:border-slate-700/60 shadow-card dark:shadow-slate-900/40 ${noPad ? "" : "p-4 sm:p-5"} ${hover ? "card-hover cursor-pointer" : ""} ${className}`}>
      {(title || action) && (
        <div className="flex items-center justify-between mb-3.5 pb-2.5 border-b border-border/80 dark:border-slate-800">
          <div>
            {title && <h3 className="text-sm sm:text-base font-bold text-ink dark:text-white">{title}</h3>}
            {subtitle && <p className="text-xs text-muted mt-0.5">{subtitle}</p>}
          </div>
          {action && <div>{action}</div>}
        </div>
      )}
      {children}
    </div>
  );
}
